// ── tableSounds — звуки покерного стола темы «Колода» ───────────────────────────
// Настоящие записи фишек и карт (набор Kenney «Casino Audio», CC0 — public/sounds/table/LICENSE.txt;
// тишина в начале срезана, громкость выровнена, чтобы стук звучал сразу по нажатию):
//  • кнопка-фишка (data-chip) — фишку кладут на стол (chip-1…3, каждый раз случайная);
//    другая кнопка, строка, вкладка — тихий стук фишки о фишку (tap-1…3);
//  • касание мимо кнопок: по сукну — глухой стук костяшками, как «чек» за покерным столом
//    (синтез: такой записи в наборе нет), по панели или окну — карта ложится на сукно (place).
//    Звучит по отпусканию, если палец не сдвинулся, — прокрутка молчит;
//  • повторение: новая карта скользит по столу (slide), переворот — шлепок карты (place);
//    «Хорошо» — фишки в стопку (win-1/2), «Легко» — горсть фишек (win-big), «Трудно» — одна
//    фишка, «Снова» — карту смахивают со стола (miss); каждые 5 подряд и конец подхода — горка
//    фишек (pile), выполненный план — две горки.
// Молчит там же, где «Аркада» (soundGate.js): выключено в настройках, играет аудио или видео,
// текст читается вслух. Файлы (~300 КБ) грузятся, только когда тема включена.
//
//   startTableSounds() / stopTableSounds() — App по набору темы (kit.sounds 'table')
//   tableAnswer / tableCard / tableCelebrate — через answerSound / cardSound / celebrate (arcadeJuice.js)

import { PRESSABLE, QUIET, mediaBusy, uiSoundsEnabled } from './soundGate';

const FILES = ['chip-1', 'chip-2', 'chip-3', 'tap-1', 'tap-2', 'tap-3', 'place', 'slide-1', 'slide-2',
  'win-1', 'win-2', 'win-big', 'miss', 'pile'];
const buffers = {};
let loading = null;
let on = false;
let actx = null;
let off = null;

export const tableSoundsOn = () => on;

// Расшифровываем заранее в OfflineAudioContext: обычный AudioContext до первого нажатия
// создавать нельзя (браузер ругается), а готовый AudioBuffer играет в любом.
function load() {
  if (loading) return loading;
  const OAC = window.OfflineAudioContext || window.webkitOfflineAudioContext;
  if (!OAC || !window.fetch) { loading = Promise.resolve(); return loading; }
  let dec;
  try { dec = new OAC(1, 1, 32000); } catch { loading = Promise.resolve(); return loading; }
  const base = `${process.env.PUBLIC_URL || ''}/sounds/table/`;
  loading = Promise.all(FILES.map((n) => fetch(`${base}${n}.wav`)
    .then((r) => (r.ok ? r.arrayBuffer() : null))
    .then((ab) => ab && new Promise((done) => dec.decodeAudioData(ab, (b) => { buffers[n] = b; done(); }, () => done())))
    .catch(() => {})));
  return loading;
}

function ctx() {
  if (!on || !uiSoundsEnabled() || mediaBusy()) return null;
  try {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    if (!actx) actx = new AC({ latencyHint: 'interactive' });
    if (actx.state === 'suspended') actx.resume().catch(() => {});
    return actx;
  } catch { return null; }
}

// Запись: громкость, задержка; высота чуть гуляет — два одинаковых стука подряд не звучат «машинно».
function play(name, vol = 0.4, at = 0) {
  const a = ctx();
  const b = buffers[name];
  if (!a || !b) return;
  const src = a.createBufferSource();
  const g = a.createGain();
  src.buffer = b;
  src.playbackRate.value = 0.94 + Math.random() * 0.12;
  g.gain.value = vol;
  src.connect(g).connect(a.destination);
  src.start(a.currentTime + at);
}
const pick = (base, n) => `${base}-${1 + Math.floor(Math.random() * n)}`;

// Стук костяшками по сукну: низкий глухой «бум» стола и мягкий шлепок по ткани.
function knock(at = 0) {
  const a = ctx();
  if (!a) return;
  const t0 = a.currentTime + at;
  const f = 105 + Math.random() * 25;
  const o = a.createOscillator();
  const g = a.createGain();
  o.type = 'sine';
  o.frequency.setValueAtTime(f, t0);
  o.frequency.exponentialRampToValueAtTime(f * 0.55, t0 + 0.1);
  g.gain.setValueAtTime(0.0001, t0);
  g.gain.exponentialRampToValueAtTime(0.32, t0 + 0.004);
  g.gain.exponentialRampToValueAtTime(0.0001, t0 + 0.13);
  o.connect(g).connect(a.destination);
  o.start(t0);
  o.stop(t0 + 0.15);
  const n = Math.floor(a.sampleRate * 0.03);
  const buf = a.createBuffer(1, n, a.sampleRate);
  const ch = buf.getChannelData(0);
  for (let i = 0; i < n; i++) ch[i] = (Math.random() * 2 - 1) * (1 - i / n) ** 2;
  const src = a.createBufferSource();
  const lp = a.createBiquadFilter();
  const ng = a.createGain();
  src.buffer = buf;
  lp.type = 'lowpass';
  lp.frequency.value = 900;
  ng.gain.value = 0.22;
  src.connect(lp).connect(ng).connect(a.destination);
  src.start(t0);
}

export function tableCard(kind = 'flip') {
  if (kind === 'deal') play(pick('slide', 2), 0.3);
  else play('place', 0.32);
}

export function tableAnswer(kind, combo = 0) {
  if (kind === 'again') play('miss', 0.3);
  else if (kind === 'hard') play(pick('chip', 3), 0.32);
  else if (kind === 'easy') play('win-big', 0.42);
  else play(pick('win', 2), 0.42);
  if (kind !== 'again' && combo >= 5 && combo % 5 === 0) play('pile', 0.32, 0.12);
}

export function tableCelebrate(jackpot = false) {
  play('pile', 0.45);
  if (jackpot) { play('win-big', 0.4, 0.3); play('pile', 0.4, 0.45); }
}

// ── Нажатия и касания ───────────────────────────────────────────────────────
let lastTap = 0;
let tap = null; // { id, x, y, t, panel }
function onDown(e) {
  const el = e.target?.closest?.(PRESSABLE);
  if (!el) {
    tap = e.target?.closest?.(QUIET) ? null
      : { id: e.pointerId, x: e.clientX, y: e.clientY, t: performance.now(), panel: !!e.target?.closest?.('[data-panel], [data-surface], [role="dialog"]') };
    return;
  }
  tap = null;
  if (el.disabled || el.getAttribute('aria-disabled') === 'true') return;
  const now = performance.now();
  if (now - lastTap < 40) return;
  lastTap = now;
  if (el.closest('[data-chip]')) play(pick('chip', 3), 0.42);
  else play(pick('tap', 3), 0.2);
}
function onUp(e) {
  const tp = tap;
  tap = null;
  if (!tp || tp.id !== e.pointerId || performance.now() - tp.t > 600 || Math.hypot(e.clientX - tp.x, e.clientY - tp.y) > 10) return;
  if (window.getSelection?.()?.toString()) return;
  if (tp.panel) play('place', 0.16);
  else knock();
}

export function startTableSounds() {
  if (on || typeof document === 'undefined') return;
  on = true;
  load();
  document.addEventListener('pointerdown', onDown, true);
  document.addEventListener('pointerup', onUp, true);
  off = () => {
    document.removeEventListener('pointerdown', onDown, true);
    document.removeEventListener('pointerup', onUp, true);
  };
}

export function stopTableSounds() {
  if (!on) return;
  on = false;
  off?.();
  off = null;
  tap = null;
}
